import { useCallback } from 'react'

import { useAuthMember } from '@tribeplatform/react-sdk/hooks'

import { useSegment } from '../../../../providers/SegmentProvider.js'
import { SegmentCheckoutStartedEventProps } from '../types.js'

interface TrackFunctionProps {
  planId: string
  planName: string
  planAmount: number
  planInterval: string
}

export const useTrackCheckoutStarted = () => {
  const segment = useSegment()

  const { data: member } = useAuthMember()
  const { id, email, name } = member || {}

  const trackCheckoutStarted = useCallback(
    async ({
      planName,
      planAmount,
      planInterval,
      planId,
    }: TrackFunctionProps) => {
      if (!id) {
        return
      }

      const eventProps: SegmentCheckoutStartedEventProps = {
        email,
        name,
        plan_id: planId,
        plan_name: planName,
        plan_amount: planAmount,
        plan_amount_whole: Math.floor(planAmount / 100),
        plan_interval: planInterval,
      }

      await segment.identify({ id, email, name })
      await segment.track('Checkout Started', eventProps)
    },
    [id, email, name, segment],
  )
  return {
    trackCheckoutStarted,
  }
}
